import { useEffect } from "react";
import AppRoutes from "./routes/AppRoutes";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();
  
  useEffect(() => {
    console.log('📍 Current location:', location.pathname);
    console.log('🔍 Search params:', location.search);
    console.log('🏷️ Hash:', location.hash);
  }, [location]);

  console.log('🔄 App component rendering');
  return <AppRoutes />;
}

export default App;